import { AnimatePresence, motion } from 'motion/react';
import './GiftReceivedModal.css';

interface Props {
  show: boolean;
  senderName: string;
  productName: string;
  onClose: () => void;
}

export default function GiftReceivedModal({ show, senderName, productName, onClose }: Props) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div className="grm-overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose}>
          <motion.div className="grm-card" initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.9, opacity: 0 }} transition={{ type: 'spring', damping: 25, stiffness: 300 }} onClick={e => e.stopPropagation()}>
            <div className="grm-icon"></div>
            <div className="grm-title">{senderName} угостил(а) вас!</div>
            <div className="grm-body">{senderName} решил угостить вас и добавил <strong>{productName}</strong> к вашему заказу!</div>
            <div className="grm-footer">Не забывайте угощать друзей </div>
            <button className="grm-btn" onClick={onClose}>Понятно</button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
